/**
 * Menu model and view resolution of the settings page, mirroring the native settings screen:
 * a section list, an action group and a split view on wide screens.
 */
export const SETTINGS_SECTIONS = ['events', 'language', 'imprint', 'privacy'];

const SECTION_LABELS = {
    events: 'settingsMoreEvents',
    language: 'settingsLanguage',
    imprint: 'imprint',
    privacy: 'privacyPolicy',
};

/** Section entries and the action group with their translation keys; logout is left out when the build disables it. */
export function settingsMenu({ disableLogout = false } = {}) {
    const sections = SETTINGS_SECTIONS.map((key) => ({ key, label: SECTION_LABELS[key] }));
    const actions = [{ key: 'back', label: 'settingsBackToEvent' }];
    if (!disableLogout) {
        actions.push({ key: 'logout', label: 'settingsLogout' });
    }
    return { sections, actions };
}

/**
 * Which panes to show for the section in the route. The split view always needs a section
 * and falls back to the first one (like the native tablet layout); stacked, an unknown section
 * goes back to the list. `redirect` is the section the route should be replaced with, '' for
 * the list and null when the route is fine as it is.
 */
export function resolveSettingsView({ section, split }) {
    const known = SETTINGS_SECTIONS.includes(section);
    if (split) {
        return {
            showMenu: true,
            showDetail: true,
            section: known ? section : SETTINGS_SECTIONS[0],
            redirect: known ? null : SETTINGS_SECTIONS[0],
        };
    }
    if (known) {
        return { showMenu: false, showDetail: true, section, redirect: null };
    }
    return { showMenu: true, showDetail: false, section: null, redirect: section ? '' : null };
}
